import partition from "lodash.partition"

import { ObjectCard } from "web/components"
import { useBatchPhotos } from "web/hooks/data"

export default function CardView({
  subjectType,
  data,
  viewType,
  viewId,
  onSelectionChanged,
  onItemClick,
}) {
  const batchPhotos = useBatchPhotos({
    viewType,
    viewId,
  })

  const [stickyCards, otherCards] = partition(data, (card) => card.sticky)

  return (
    <div
      className="grid min-h-0 grow gap-5 overflow-y-auto px-3 md:px-6"
      style={{ gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))" }}
    >
      {stickyCards.concat(otherCards).map((card) => (
        <ObjectCard
          key={card.id}
          subjectType={subjectType}
          data={card}
          photoUrl={batchPhotos[card.id]}
          onSelectionChanged={onSelectionChanged}
          onItemClick={() => onItemClick(card, data)}
          isSticky={card.sticky}
        />
      ))}
    </div>
  )
}
